/**
 * Steadily moving this stuff to more appropriate modules and off the window
 */
define('all',['require','utils','lazyload','cookieutil'],function (require) {
    var utils = require('utils');
    var LazyLoad = require('lazyload');
    window.CookieUtil = require('cookieutil');
    window.roundNumber = utils.roundNumber;
    window.requestQueryString = utils.querystring;
    window.numberWithCommas = utils.numberWithCommas;

    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) { //note the parenthesis for the backreference
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, "");
    };
    String.prototype.toTitleCase = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }); //word character, followed by 0 or many non-whitespace characters
    };

    window.persistError = function(message, scriptUrl, lineNumber, sendEmail, column, err) {
        if (scriptUrl == null) { scriptUrl = ''; }
        if (lineNumber == null) {lineNumber = "";}
        if (sendEmail == null) { sendEmail = true; }
        if (column == null) {column = '';}
        var stack;
        try {
            stack = printStackTrace().join("\n");
        } catch (err) {
            stack = 'NO STACK BECAUSE printStackTrace errored';
        }
        $.post("/public/javascriptErrorAJAX.aspx",
        {
            message: Utilities.htmlEncode('{0} on {1} at {2} ({3}:{4}) STACK: {5}'.format(
                message,
                window.location.toString(),
                scriptUrl,
                lineNumber,
                column,
                stack
            )),
            sendEmail: sendEmail
        });
    };

    window.onerror = function (message, url, lineNumber, column, err) {
        $('form').show(); //at least try to show the page, despite the js error, in case it's minor. TODO: think through this more...
        persistError(message, url, lineNumber, false, column, err);
    };

    /**
     * global ajax error handler http://api.jquery.com/ajaxerror/
     */
    $(document).ajaxError(function (event, xhr, settings, thrownError) {
        if (xhr.status === 401) { //unauthorized
            window.location = "/login.aspx?access=false&ReturnURL=" + window.encodeURIComponent(window.location);
        } else if (utils.tryGetValue(xhr, 'responseJSON.Location') != null) { //redirect
            window.location = xhr.responseJSON.Location;
        }
    });

    /**
     * Pass JSON to the server, return JSON to client (instead of form-url-encoded).
     * e.g. deserializing CRS_2.Core.Session.Transaction has calculated properties that JSON.NET handles no problem, but whatever is used to extract form-url-encoded data doesn't handle it correctly and "property" doesn't get set before its dependent properties are retrieved
     * @param {String} url 
     * @param {Object} data 
     * @returns {Promise} Jquery-deferred 
     */
    $.postJSON = function(url, data) {
        return $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        });
    }
    
    $.getLocalItem = function(key) {
        return JSON.parse(localStorage.getItem(key));
    }
    
    $.setLocalItem = function(key, item) {
        localStorage.setItem(key, JSON.stringify(item));
    }
    
    $.removeLocalItem = function(key) {
        localStorage.removeItem(key);
    }

    //define console.log if not there in case some get left in code
    if (typeof console == "undefined") {
        this.console = { log: function () { } };
    }

    window.is18 = function(source, args) {
        var TheirBirthDate = new Date(args.Value.toString()),
            valid = false;

        if (TheirBirthDate != null) {
            var Today = new Date(),
                age = (Today.getFullYear() - TheirBirthDate.getFullYear());

            valid = age > 18 || (age == 18 && (TheirBirthDate.getMonth() <= Today.getMonth() && TheirBirthDate.getDate() <= Today.getDate())); //if their >= 18 (if 18, have they had their bday yet)
        }
        args.IsValid = valid;
    };

    window.isDateInPast = function(source, args) {
        var Today = new Date()
        var EnteredDate = new Date(args.Value.toString());
        args.IsValid = Today > EnteredDate;
    };

    window.isDateInFuture = function (source, args) {
        var Today = new Date()
        var EnteredDate = new Date(args.Value.toString());
        if (EnteredDate != null) {
            if (Today < EnteredDate) {
                args.IsValid = true;
            } else if (Today.getMonth() == EnteredDate.getMonth() && Today.getDate() == EnteredDate.getDate() && Today.getFullYear() == EnteredDate.getFullYear()) { //less than or equal month, date, and year(don't worry about the time)
                args.IsValid = true;
            } else
                args.IsValid = false;
        }
    };

    window.isJSDate = function(source, args) {
        var EnteredDate = new Date(args.Value.toString());
        args.IsValid = !isNaN(EnteredDate);
    };

    window.preload = function(arrayOfImages) {
        $(arrayOfImages).each(function() {
            (new Image()).src = this;
        });
    };

    window.makeModalPopup = function(tab, popup) {
        $(tab).on("click", function() {
            $(popup).toggle(250);
            if (!$(this).hasClass('maintainModal')) {
                $(".modalDiv").toggle();
            }
        });
    };

    window.Utilities = {
        htmlEncode: function(value) {
            return $('<div/>').text(value).html();
        },
        htmlDecode: function(value) {
            return $('<div/>').html(value).text();
        },
        handleAJAXResponse: function(response, successCallBack, errorCallback) {
            var respObj = {};

            if (response.length > 0) {
                try {
                    respObj = JSON.parse(response);
                } catch (err) {
                    persistError("Error parsing AJAX response");
                    respObj.error = "An error occurred. Please try again. If the error persists, please contact Adestinn, so we can help.";
                }
            }

            if (respObj != null && respObj.error != undefined) {
                errorCallback.call(undefined, respObj.error);
                if (respObj.moveLocation != undefined && respObj.moveLocation.length > 0) {
                    window.location = respObj.moveLocation;
                }
            } else {
                successCallBack.call(undefined, respObj);
            }
        },
        /**
         * Parses out the message from the server of an xhr that errored
         * @param {jquery xhr} xhr 
         * @returns {Array<string>} 
         */
        getFriendlyErrors: function(xhr) {
            var single = utils.tryGetValue(xhr, 'responseJSON.Message');
            var many = utils.tryGetValue(xhr, 'responseJSON.Messages');
            return many == null && single == null ? [] : many == null ? [single] : many;
        },
        setError: function(message, $msgDiv) {
            $msgDiv.addClass("alert alert-error").removeClass("alert-info alert-warning").html(message).show();
        },
        removeError: function ($msgDiv) {
            $msgDiv.removeClass("alert alert-error").hide();
        },
        setInfo: function(message, $msgDiv) {
            $msgDiv.addClass("alert alert-info").removeClass("alert-error alert-warning").html(message).show();
        },
        setWarning: function(message, $msgDiv) {
            $msgDiv.addClass("alert alert-warning").removeClass("alert-error alert-info").html(message).show();
        },
        /**
            * if the enter key is pushed while an input has focus inside the given "$form", triggler a click of the given "$btn"
            * @param {jquery object} $form 

            * @param {jquery object} $btn  
            */
        setDefaultButton: function($form, $btn) {
            $('input', $form).off('keypress').on("keypress", function(e) {
                if (e.which === 13) {
                    var disabled = $btn.prop("disabled"),
                        hidden = $btn.css("display") === "none",
                        notVisible = $btn.css("visibility") === "hidden";

                    //console.log("disabled: " + $btn.prop("disabled"));
                    //console.log("display: " + $btn.css("display"));
                    //console.log("notVisible: " + $btn.css("visibility"));

                    if (!disabled && !hidden && !notVisible) {
                        $btn.trigger("click");
                        return false;
                    }
                }
            });
        },
        /**
         * clear handlers that were set by "setDefaultButton"
         */
        unSetDefaultButton: function($form) {
            $('input', $form).off('keypress');
        },
        specialFancy: {
            maxWidth: 800,
            maxHeight: 600,
            fitToView: false,
            autoSize: false,
            closeClick: false,
            "beforeClose": function() {
                $(".fancybox-iframe").hide();
                $(".overlay-fixed").hide();
            },
            openEffect: 'none',
            closeEffect: 'none',
            padding: 0
        },

        /**
         * Set up the given selector to be a daterange picker
         * Note that we also handle when the daterange picker is cleared yeah? Oh very nice? You like?
         * Also push the to date out just under a day so the full day is included. e.g. if they have 9/26-9/26, we technically get 9/26 12am to 9/26 11:59:59pm
         * @param {String} boxSelector 
         * @param {Function} onChange 
         * @param {Object} options (Optional) will extend the options, overwrite etc
         * @param {DateRane} initVal (Optional) will set box text and value accordingly { start: {Date}, end: {Date} }
         */
        generalDateRangePicker: function (boxSelector, onChange, opts, initialRange) {
            var allTimeFilter = {
                startDate: Date.parse("7/29/2010"),
                endDate: Date.today()
            };
            var options = $.extend({
                opens: 'left',
                separator: " - ",
                format: "M/d/yyyy", // hh:mm '
                ranges: {
                    'All Time': [allTimeFilter.startDate, allTimeFilter.endDate],
                    'This Year': [Date.parse("1/1/" + Date.today().getFullYear()), Date.today()],
                    'Last Month': [Date.today().moveToFirstDayOfMonth().add({ months: -1 }), Date.today().moveToFirstDayOfMonth().add({ days: -1 })],
                    'This Month': [Date.today().moveToFirstDayOfMonth(), Date.today()], // no need to call .moveToLastDayOfMonth() in this application...
                    'Last 30 Days': [Date.today().add({ days: -29 }), 'today'],
                    'Last 7 Days': [Date.today().add({ days: -6 }), 'today'],
                    'Yesterday': ['yesterday', 'yesterday'],
                    'Today': ['today', 'today']
                },
                locale: {
                    fromLabel: 'From',
                    toLabel: 'To'
                }
            }, opts);
            var $box = $(boxSelector);
            if (initialRange != null) {
                $box.val('{0}{1}{2}'.format(initialRange.Start.toString(options.format), options.separator, initialRange.End.toString(options.format)));
                onChange(initialRange.Start, initialRange.End);
            }
            $box.daterangepicker(options, onChange).on('change', function () {
                if ($box.val().trim() === '') {
                    onChange(null, null);
                }
            });
        },

        /**
         * Brings the end date up to the end of its date and put into .net json date format
         * @param {Date} start 
         * @param {Date} end 
         * @returns {json string} 
         */
        getTimeFilter: function (start, end) {
            if (start != null && end != null) {
                var format = 'yyyy-MM-ddTHH:mm:ss';
                var endOfEnd = Date.parse(end.toString('M/d/yyyy')).add({ days: 1, milliseconds: -1 });
                return JSON.stringify({ Start: start.toString(format), End: endOfEnd.toString(format) });
            } else {
                return JSON.stringify({ Start: '', End: '' });
            }
        },

        cleansePhone: function(value) {
            return value.replace(/[^\d]/g, '');
        },

        /**
          * Phone numbers with an area code are at least 10 digits in U.S. If we need to collect extension, simply add a separate extension box
          * @param {} sender 
          * @param {} eventArgs 
          */
        validatePhone: function(sender, eventArgs) {
            var cleansedValue = this.cleansePhone(eventArgs.Value);
            var phoneBox = $(sender).prevAll('input'); //the sender is actually the span for the asp.net validation control...so get the previous input
            phoneBox.val(cleansedValue);
            eventArgs.IsValid = cleansedValue.length >= 10;
        },
        
        formatPhoneNumber: function(phoneNumberString) {
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
              return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
            return phoneNumberString;
        },

        /**
         * Call lazy load plugin on the given element with our preferred settings
         * http://verlok.github.io/lazyload/
         * @returns {LazyLoad} (don't forget to destroy it when you're done. And you can use "update" when you load in dynamic content.)
         */
        lazyLoad: function () {
            return new LazyLoad({
                placeholder: '{0}images/placeholder.gif'.format(window.ServerData.StaticContentUrl)
            });
        }
    };

    /*
        Fill in any missing crap that can cause errors
    */
    if (window['__gCrWeb'] == null) { window['__gCrWeb'] = {}; }
});
